"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
exports.RbacContext = react_1.createContext(null);
exports.useRbac = function () { return react_1.useContext(exports.RbacContext); };
exports.RbacProvider = function (_a) {
    var children = _a.children, roleProvider = _a.roleProvider, grants = _a.grants, onEvent = _a.onEvent;
    function can(action) {
        var currentRoles = roleProvider();
        for (var _i = 0, currentRoles_1 = currentRoles; _i < currentRoles_1.length; _i++) {
            var role = currentRoles_1[_i];
            var grantsForRole = grants[role];
            if (!grantsForRole) {
                continue;
            }
            for (var _a = 0, _b = Object.values(grantsForRole); _a < _b.length; _a++) {
                var grantedActions = _b[_a];
                if (grantedActions.includes(action)) {
                    onEvent(currentRoles, action, true, role);
                    return true;
                }
            }
        }
        onEvent(currentRoles, action, false, null);
        return false;
    }
    return (react_1.default.createElement(exports.RbacContext.Provider, { value: { can: can } }, children));
};
